/*
 * Public API Surface of fire-admin
 */

export * from './lib/fire-admin.service';
export * from './lib/fire-admin.component';
export * from './lib/fire-admin.module';
